import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagZM = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#496E2D",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M34.783 25H25v25c2.922 0 5.727-.503 8.333-1.424L34.783 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FF9811",
  d: "M41.666 43.632C46.78 39.055 50 32.404 50 25h-9.783l1.45 18.632Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M33.333 25v23.576a24.986 24.986 0 0 0 8.334-4.944V25h-8.334Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FF9811",
  d: "M46.195 16.305h-6.521a2.174 2.174 0 0 0-4.348 0h-6.522c0 1.2 1.046 2.174 2.246 2.174h-.072c0 1.2.973 2.174 2.174 2.174 0 1.2.973 2.174 2.174 2.174h4.348c1.2 0 2.173-.974 2.173-2.174 1.201 0 2.175-.973 2.175-2.174h-.073c1.2 0 2.246-.973 2.246-2.174Z"
}));
FlagZM.displayName = 'FlagZM';
export default withFlagWrapper(FlagZM);
//# sourceMappingURL=index.js.map